import React from 'react';
import {createStyles} from "@mui/material";
import { Theme } from '@mui/material/styles';
import { useEmployees } from '../Data/EmployeeData';
import { useSelector } from 'react-redux';
import { IEmployeeRole } from '../Interfaces/Admin/IEmployeeRole';
import {IEmployeeEmployeeRole} from "../Interfaces/Admin/IEmployeeEmployeeRole";
import {ILookupItems} from "../Interfaces/ILookupItems";
import { ColumnInfo, GenericGrid } from '@amsanalytics/react-shared-library';
import { GridFilterCellProps } from '@progress/kendo-react-grid';
import { useNavigate } from 'react-router';
import { AppState } from '../store/rootReducer';
import {Organization} from "@amsanalytics/react-shared-library/build/Models/Organization";

// const useStyles: any = makeStyles((theme: Theme) =>
//   createStyles({
//     hover: {      
//       "&:hover": {
//         cursor: 'pointer'
//       }
//     },
//     container: {
//       maxHeight: "80vh",
//     },
//   })
// );

export interface EmployeesProps {
}

interface IEmployeeItem { 
  employeeId: string,
  adUserId: string,
  firstName: string,
  lastName: string,
  emailAddress: string,
  employeeEmployeeRoles: string,
  organizations: string,
  phoneNumber: string,
  availabilityStatus: string,
  lastActivityDate: string,
  active: string
}


interface EmployeeGridColumn extends ColumnInfo {
  filtercell?: React.ComponentType<GridFilterCellProps>;
  filterTitle?: string;
}

export const Employees: React.FC<EmployeesProps> = props => {
  const { data: employees } = useEmployees();
  const organizations: Organization[] = useSelector((state: AppState) => state.applications.lookups.organizations);
  const employeeRoles: IEmployeeRole[] = useSelector((state: AppState) => state.applications.employeeRoles);
  const lookups: ILookupItems = useSelector((state: AppState) => state.applications.lookups);
  const navigate = useNavigate();
  let employeeItems: IEmployeeItem[] = [];

  const getEmployeeRolesString = (employeeEmployeeRoles: IEmployeeEmployeeRole[]) => {
    const employeeRoleStrings: string[] = [];
    employeeEmployeeRoles.map(eer => {
      const employeeRoleName = employeeRoles?.find(er => er.id === eer.employeeRoleId)?.name;
      employeeRoleName && employeeRoleStrings.push(employeeRoleName);
    });
    return employeeRoleStrings.join(', ');
  };

  employees?.map((e, i) =>{
    employeeItems.push({
      employeeId: e.id,
      adUserId: e.adUserId,
      firstName: e.firstName,
      lastName: e.lastName,
      emailAddress: e.emailAddress,
      employeeEmployeeRoles: e.employeeEmployeeRoles ? getEmployeeRolesString(e.employeeEmployeeRoles) : '',
      organizations: organizations?.find(o => o.id === e.organizationId)?.name || '',
      phoneNumber: e.phoneNumber,
      availabilityStatus: e.availabilityStatusId ? lookups.availabilityStatuses.find(av => av.id === e.availabilityStatusId)?.name || '' : '',
      lastActivityDate: e.lastActivityDate ? new Date(e.lastActivityDate).toLocaleString() : '',
      active: !e.deleted ? "Yes" : ""
    });

  });
  
  const genericGridColumns: EmployeeGridColumn[] = [];
  genericGridColumns.push({ title: "AD User", field: "adUserId", width: '300px' });
  genericGridColumns.push({ title: "First Name", field: "firstName", width: '180px' });
  genericGridColumns.push({ title: "Last Name", field: "lastName", width: '180px' });
  genericGridColumns.push({ title: "Email", field: "emailAddress", width: '300px' });
  genericGridColumns.push({ title: "Role(s)", field: "employeeEmployeeRoles", width: '170px' });
  genericGridColumns.push({ title: "Location", field: "organizations", width: '250px' });
  genericGridColumns.push({ title: "Phone #", field: "phoneNumber", width: '150px' });
  genericGridColumns.push({ title: "Availability", field: "availabilityStatus", width: '150px' });
  genericGridColumns.push({ title: "Last Activity Time", field: "lastActivityDate", width: '200px' });
  genericGridColumns.push({ title: "Active", field: "active", width: '100px' });

  return (
    <>
      {true ? (
        <>
          <GenericGrid<IEmployeeItem>
            columns={genericGridColumns}
            items={employeeItems ? employeeItems : []}
            itemName={'Employees'}
            totalCount={employeeItems?.length || 0}
            pageSizes={[10, 20, 50, 100]}
            style={{ height: 'calc(100vh - 80px)' }}
            disableEditing={true}
            disableAdding={true}
            disableGrouping={true}
            onItemSelected={(e) => {
              navigate(`/Employee/${e.employeeId}`);
            }}
          />
        </>
      ) : null}
    </>
  );
}
